// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React, { useCallback } from 'react'
import { removeCommentAttachment } from '../helpers'
import { success } from 'react-notification-system-redux'
import ConfirmationModal from 'components/Modals/ConfirmationModal'
import { useDispatch } from 'react-redux'
import { useModalContext } from 'components'

const useHandleDeleteAttachment = props => {
  const {
    commentFileId,
    deleteAttachment,
    idRoot,
    removeSingleAttachmentFromComment,
  } = props

  const dispatch = useDispatch()

  const {
    closeContextModal,
    openContextModal,
  } = useModalContext()

  return useCallback(() => {
    const confirmAction = async () => {
      const message = await dispatch(removeCommentAttachment(() => deleteAttachment(commentFileId)))

      if (message) {
        dispatch(success({ message }))

        removeSingleAttachmentFromComment(commentFileId)

        closeContextModal()
      }
    }

    openContextModal(
      <ConfirmationModal
        confirmAction={confirmAction}
        heading={'Delete Attachment:'}
        idRoot={`${idRoot}-confirmation`}>
        <p id={`${idRoot}-confirmation-message`}>
          {'Are you sure you want to delete this attachment?'}
        </p>
      </ConfirmationModal>
    )
  }, [commentFileId, deleteAttachment])
}

export default useHandleDeleteAttachment
